import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid mb-3" }
const _hoisted_2 = { class: "col-12 lg:col-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = {
  key: 0,
  class: "col-12 lg:col-8"
}
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "col-12 lg:col-6" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_17 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_StatisticsByPayments = _resolveComponent("StatisticsByPayments")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_BalancesSum = _resolveComponent("BalancesSum")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_UserColumn = _resolveComponent("UserColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_Entries = _resolveComponent("Entries")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.$t('top_up_balance')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.paymentForm.method,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentForm.method) = $event)),
              modelModifiers: { number: true },
              label: _ctx.$t('method'),
              options: _ctx.filteredPaymentMethods,
              "option-label-translate": ""
            }, null, 8, ["modelValue", "label", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FieldNumber, {
              modelValue: _ctx.paymentForm.amount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentForm.amount) = $event)),
              modelModifiers: { number: true },
              label: _ctx.$t('amount'),
              min: _ctx.paymentAmountMin,
              "max-fraction-digits": 0,
              prefix: "$"
            }, null, 8, ["modelValue", "label", "min"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FieldText, {
              modelValue: _ctx.paymentForm.promocode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentForm.promocode) = $event)),
              modelModifiers: { trim: true },
              name: "promocode",
              "errors-map": _ctx.paymentFormErrors,
              label: _ctx.$t('promocode')
            }, null, 8, ["modelValue", "errors-map", "label"])
          ]),
          _createVNode(_component_PrimeVueButton, {
            class: "p-button-success w-full",
            icon: "pi pi-credit-card",
            label: _ctx.$t('pay'),
            loading: _ctx.paymentLoading,
            onClick: _ctx.addPayment
          }, null, 8, ["label", "loading", "onClick"])
        ])
      ]),
      (_ctx.activeUser.isStaff())
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_StatisticsByPayments)
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, {
                  class: "mb-3",
                  height: "120px"
                })
              ]),
              _: 1
            })),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalancesSum)
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, {
                      class: "mb-3",
                      height: "120px"
                    })
                  ]),
                  _: 1
                }))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Entries, {
      title: _ctx.$t('payments'),
      "show-add-button": false,
      "href-prefix": "payments"
    }, {
      tables: _withCtx(() => [
        _createVNode(_component_EntriesDataTable, {
          entries: _ctx.payments,
          "entries-handler": _ctx.fetchPaymentsWrapper,
          "show-actions-column": false,
          "href-prefix": "payments"
        }, {
          columns: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "id",
              header: "ID",
              sortable: ""
            }),
            (_ctx.activeUser.isSuperAdmin())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 0,
                  field: "project_id",
                  header: _ctx.$t('project'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.project.name), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (!_ctx.activeUser.isAffiliate())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 1,
                  field: "user_id",
                  header: _ctx.$t('user'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserColumn, {
                          user: data.user
                        }, null, 8, ["user"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "method",
              header: _ctx.$t('method'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.PAYMENT_METHODS_MAP[data.method].translate_key)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "amount",
              header: _ctx.$t('amount'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$n(data.amount, 'payout')), 1),
                  (data.status === _ctx.PAYMENT_STATUS_NEW && !data.is_expired && data.payment_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "ml-2",
                        href: data.payment_url,
                        target: "_blank"
                      }, [
                        _createVNode(_component_PrimeVueButton, {
                          class: "p-button-rounded p-button-text p-button-success",
                          icon: "pi pi-credit-card",
                          label: _ctx.$t('pay')
                        }, null, 8, ["label"])
                      ], 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              header: _ctx.$t('balance')
            }, {
              body: _withCtx(({ data }) => [
                (data.status === _ctx.PAYMENT_STATUS_COMPLETED)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$n(data.balance_before, 'payout')) + " → " + _toDisplayString(_ctx.$n(data.balance_after, 'payout')), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_15
                    ], 64))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "promocode_id",
              header: _ctx.$t('promocode')
            }, {
              body: _withCtx(({ data }) => [
                (data.promocode_id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(data.promocode.promocode), 1),
                      (data.promocode.description)
                        ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                            key: 0,
                            class: "ml-2",
                            value: data.promocode.description,
                            severity: "info"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_16
                    ], 64))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "status",
              header: _ctx.$t('status'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PrimeVueTag, {
                  value: _ctx.$t(_ctx.PAYMENT_STATUSES_MAP[data.status].translate_key),
                  severity: _ctx.PAYMENT_STATUSES_MAP[data.status].severity
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "updated_at",
              header: _ctx.$t('updated_at'),
              sortable: ""
            }, null, 8, ["header"])
          ]),
          _: 1
        }, 8, ["entries", "entries-handler"])
      ]),
      filters: _withCtx(() => [
        (_ctx.activeUser.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.paymentsFilters.project_id,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentsFilters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                modelModifiers: { number: true },
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name"
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.paymentsFilters.user_id,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentsFilters.user_id) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('user'),
            loading: _ctx.usersLoading,
            options: _ctx.users.data,
            "option-value": "id",
            "option-label": "compiled_name",
            filter: true
          }, null, 8, ["modelValue", "label", "loading", "options"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.paymentsFilters.method,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paymentsFilters.method) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('method'),
            "show-clear": true,
            options: _ctx.filteredPaymentMethods
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.paymentsFilters.status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentsFilters.status) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('status'),
            "show-clear": true,
            options: _ctx.PAYMENT_STATUSES,
            "option-label-translate": ""
          }, null, 8, ["modelValue", "label", "options"])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}